/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_7_IntroInputs */

const en_privacy_section_7_intro = /** @type {(inputs: Privacy_Section_7_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Under the General Data Protection Regulation, you have the following rights:`)
};

const lv_privacy_section_7_intro = /** @type {(inputs: Privacy_Section_7_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saskaņā ar Vispārīgo datu aizsardzības regulu Jums ir šādas tiesības:`)
};

/**
* | output |
* | --- |
* | "Under the General Data Protection Regulation, you have the following rights:" |
*
* @param {Privacy_Section_7_IntroInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_7_intro = /** @type {((inputs?: Privacy_Section_7_IntroInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_7_IntroInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_7_intro(inputs)
	return en_privacy_section_7_intro(inputs)
});